import { RecordingIndicator } from '@/components/atoms/RecordingIndicator'
import { MeetingHeader } from '@/components/molecules/Header/MeetingHeader'
import { CustomMeetingControls } from '@/components/organisms/CustomMeetingControls/CustomMeetingControls'
import { MeetingVideoGrid } from '@/components/organisms/MeetingVideoGrid'
import { AppTemplate } from '@/components/templates/AppTemplate/AppTemplate'

type MeetingDesktopProps = {
  isCameraPermissionDenied: boolean
  isMicrophonePermissionDenied: boolean
}

export function VideoMeetingDesktop({ isCameraPermissionDenied, isMicrophonePermissionDenied }: MeetingDesktopProps) {
  return (
    <AppTemplate
      header={<MeetingHeader showMeetingInfo />}
      className="bg-primary [&>div:last-child]:p-0 [&>div:last-child]:flex-none hidden lg:flex"
    >
      <div className="relative w-full h-[calc(100vh-64px)]">
        {/* Video area - all space except controls */}
        <div className="absolute inset-0 bottom-20">
          <MeetingVideoGrid />
        </div>

        {/* Controls - fixed at bottom */}
        <div className="fixed bottom-0 left-0 right-0 h-20 flex items-center justify-center bg-primary/90 backdrop-blur-sm z-40">
          <CustomMeetingControls
            isCameraPermissionDenied={isCameraPermissionDenied}
            isMicrophonePermissionDenied={isMicrophonePermissionDenied}
            mode="video"
          />
          <div className="absolute left-11">
            <RecordingIndicator />
          </div>
        </div>
      </div>
    </AppTemplate>
  )
}
